// Beranda untuk akun yang TIDAK bisa membuka satu dashboard pun (G8 butir b,
// aturan di lib/halamanAwal.js — dirender HalamanDepan di App.js).
//
// KENAPA panel statis tanpa `api`: yang sampai ke sini justru akun yang tidak boleh
// memanggil GET /dashboard. Merender <Dashboard /> untuk mereka berarti kotak galat
// 403 + toast di layar pertama — terasa seperti aplikasi rusak, padahal izinnya memang
// begitu.
//
// KENAPA teksnya mengikuti jumlah menu (dioper Layout lewat Outlet context): menyuruh
// orang "lihat menu di kiri" padahal menunya nol adalah panel yang berbohong, dan di
// ponsel sidebar tersembunyi di balik tombol Menu — "di sebelah kiri" tidak ada di sana.
import { useOutletContext } from "react-router-dom";
import { LayoutDashboard, LogOut } from "lucide-react";

export default function BerandaTanpaDashboard() {
  const { jumlahMenuTerlihat = 0, keluar } = useOutletContext() || {};
  const adaMenu = jumlahMenuTerlihat > 0;

  return (
    <div className="p-4 md:p-8 max-w-[900px]" data-testid="beranda-tanpa-dashboard">
      <div className="bg-white border border-slate-200 rounded-xl p-6 md:p-8 text-center">
        <div className="w-12 h-12 mx-auto rounded-full bg-slate-100 grid place-items-center text-slate-400 mb-3">
          <LayoutDashboard className="w-6 h-6" />
        </div>
        <h1 className="font-display text-lg font-bold text-slate-900 mb-2">Belum ada dashboard</h1>
        {adaMenu ? (
          <p className="text-sm text-slate-600" data-testid="beranda-tanpa-dashboard-ada-menu">
            Akun Anda belum punya dashboard. Menu yang boleh Anda buka ada di daftar menu{" "}
            <span className="hidden lg:inline">di sebelah kiri</span>
            <span className="lg:hidden">— tekan tombol Menu di kiri atas</span>.
          </p>
        ) : (
          <div data-testid="beranda-tanpa-dashboard-tanpa-menu">
            <p className="text-sm text-slate-600">
              Akun Anda belum diberi akses ke menu apa pun. Hubungi admin untuk mengatur izin akun ini.
            </p>
            <button
              type="button"
              data-testid="beranda-tanpa-dashboard-keluar"
              onClick={() => { if (window.confirm("Keluar dari akun ini?")) keluar?.(); }}
              className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-rose-50 hover:bg-rose-100 text-rose-700 border border-rose-200 text-sm font-medium transition-colors"
            >
              <LogOut className="w-4 h-4" />
              Keluar
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
